<!-- 单项选择题 -->
<template>
  <div class="topic_choice">
    <div class="flex topic_select mb-10">
      <!-- <div class="topic_type">多选题</div> -->
      <div class="topic_content scroll_x flex-1 mar_left_10">
        <div class="flex FlexBaseline">
          <div>{{ subQuestionNum + 1 }}、</div>
          <div class="topic_title" v-html="$Tools.handlerImg(topicInfo?.stem)" v-mathml></div>
        </div>
        <div>
          <el-checkbox-group v-model="topicInfo.doAnswer" @change="changeAnswer">
            <el-checkbox v-for="(item, index) in topicInfo?.options" :key="index" :value="item.serial.toString()"
              size="large" :disabled="disabled">
              <div class="flex FlexBaseline">
                <div>{{ item.label }} .</div>
                <div class="editor_box" v-html="$Tools.handlerImg(item.content)" v-mathml></div>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>
    <!-- <div v-if="!testType">
      <div class="topic_answer" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20">
          <div>答题结果</div>
          <div class="flex FlexBetween mt-20">
            <div>参考答案：<span class="correct_value_answer">{{
              this.getChoiceLabel(topicInfo.answer,
                topicInfo.options)
                }}</span></div>
            <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
              你的答案：<span class="error_value_answer" :class="topicInfo.isCorrect == 1
                ? 'correct_value_answer'
                : ''
                ">{{
                  this.getChoiceLabel(topicInfo.doAnswer,
                    topicInfo.options) }}</span>
              <div class="bg_line"></div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ topicInfo.score || 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div>
      <div class="topic_answer" v-if="isShowScoring || topicInfo.showAnalysis">
        <div class="answer_top p-20" v-if="getIsShow(1) || showAnswer">
          <div class="mt-20 flex FlexBetween">
            <div>参考答案：<span class="correct_value_answer">{{
              this.getChoiceLabel(topicInfo.answer,
                topicInfo.options)
                }}</span></div>
            <div class="mar_left_20 user_answer" v-if="!hideUserAnswer">
              你的答案：<span class="error_value_answer" :class="topicInfo.isCorrect == 1
                ? 'correct_value_answer'
                : ''
                ">{{
                  this.getChoiceLabel(topicInfo.doAnswer,
                    topicInfo.options) }}</span>
              <div class="bg_line"></div>
            </div>
            <div class="mar_left_20 flex">
              <div class="full_score">
                <el-image class="question_error_icon" :src="iconPath('question_error_icon.png')"
                  v-if="topicInfo.isCorrect == 2"></el-image>
                <el-image class="question_error_icon" :src="iconPath('question_correct_icon.png')"
                  v-if="topicInfo.isCorrect == 1"></el-image>
              </div>
              <div class="get_score ml-10" v-if="!hideUserAnswer">得分：{{ topicInfo.questionScore }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "GjkcH5Choice",
  props: {
    questionInfo: {},
    disabled: {
      type: Boolean,
      default: false,
    },
    subQuestionNum: {},
    isShowScoring: {
      default: false,
    },
    testType: {}, // 区分闯关，为1时是闯关,
    showAnswer:{}, // 用于测评报告弹题展示解析等
  },
  computed: {
    ...mapState({
      testExamTime: (state) => state.exam.testExamTime,
      testExamInfo: (state) => state.exam.testExamInfo,
    }),
  },

  data() {
    return {
      topicInfo: {},
    };
  },
  watch: {
    questionInfo: {
      handler(val) {
        if (val) {
          this.topicInfo = JSON.parse(val);
          // 多选题答案为数组,将正确答案也变为数组
          if (this.$Tools.empty(this.topicInfo.doAnswer)) {
            this.topicInfo.doAnswer = [];
          }
          // 判断是不是数组，不是数组转换
          if (!Array.isArray(this.topicInfo?.answer)) {
            this.topicInfo.answer = this.topicInfo?.answer?.split(",");
          }
          // 判断是否回答过
          if (
            this.topicInfo.doAnswer &&
            !Array.isArray(this.topicInfo?.doAnswer) &&
            !this.$Tools.empty(this.topicInfo.doAnswer)
          ) {
            this.topicInfo.doAnswer = this.topicInfo.doAnswer.split(",");
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() { },

  methods: {
    getIsShow(showId) {
      let flag = false;
      if (!this.$Tools.empty(this.testExamInfo.otherRule)) {
        if (!this.$Tools.empty(this.testExamInfo.otherRule.showAnswer)) {
          if (this.testExamInfo.otherRule.showAnswer.findIndex(item => item == showId) != -1) {
            flag = true;
          }
        }
      }
      return flag
    },
    getChoiceLabel(value, options) {
      if (!options) return;
      // 多选多个答案拼接
      if (typeof value == 'string') {
        value = value.split(',')
      }
      let label = "";
      options.forEach((item) => {
        value.forEach((sitem) => {
          if (item.serial == sitem) {
            label += item.label;
          }
        });
      });
      return label;
    },
    changeAnswer(value) {
      // console.log(this.topicInfo.doAnswer);
      // console.log(this.topicInfo.questionContext?.answer);
      // console.log(this.areArraysEqual(value, this.topicInfo.questionContext?.answer))
      if (this.areArraysEqual(value, this.topicInfo?.answer)) {
        this.topicInfo.isCorrect = 1;
      } else {
        this.topicInfo.isCorrect = 2;
      }
      this.topicInfo.questionScore =
        this.topicInfo.isCorrect == 1 ? this.topicInfo.score : 0; // 得分
      // this.topicInfo.questionContext.doAnswer = this.topicInfo.doAnswer.join(",");   // 保存答案
      // this.topicInfo.questionContext.isFinish = true;   // 是否已完成
      this.$emit("answerQuestion", this.topicInfo);
    },
    // 判断数组是否相同（内容）
    areArraysEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;

      // 类型归一化函数（仅转换字符串数字）
      const normalize = (item) => {
        if (typeof item === "string") {
          const num = Number(item);
          return isNaN(num) ? item : num; // 非数字字符串保留原样
        }
        return item;
      };

      // 归一化后排序
      const sortedArr1 = [...arr1].map(normalize).sort((a, b) => a - b);
      const sortedArr2 = [...arr2].map(normalize).sort((a, b) => a - b);

      // 严格比较（支持 NaN）
      return sortedArr1.every((elem, index) =>
        Object.is(elem, sortedArr2[index])
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.topic_select {
  .topic_type {
    // margin-top: 1rem;
    min-width: 45px;
    padding: 0 8px;
    height: 21px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    line-height: 21px;
    text-align: center;
    font-size: 12px;
    color: #00c758;
  }

  .topic_content {

    // overflow-x: auto;
    .topic_title {
      font-size: 16px;
      color: #242324;
      font-weight: 600;
    }

    .editor_box {
      white-space: normal;
    }
  }
}

.bottom_box {
  position: absolute;
  left: calc(50% - 60px);
  bottom: 40px;
  text-align: center;

  .btn_view {
    width: 120px;
    height: 42px;
    background: linear-gradient(90deg, #00d5c2, #00d498);
    border-radius: 21px;
    text-align: center;
    line-height: 42px;
    color: #fff;
    font-size: 18px;
  }

  .view_analysis {
    color: #13d6aa;
  }
}

.topic_answer {
  width: 100%;
  // height: 222px;
  // background: rgba(19, 214, 170, 0.05);
  border-radius: 10px;
  // padding: 20px;
  color: #666666;
  box-sizing: border-box;

  .answer_top {
    background: #F8F9FA;
    border-radius: 8px;
    width: 100%;
    box-sizing: border-box;

    .user_answer {
      position: relative;

      .bg_line {
        width: 73px;
        height: 8px;
        background: rgba(19, 214, 170, 0.2);
        position: absolute;
        bottom: 6px;
        left: 0;
      }
    }

    .question_error_icon {
      width: 26px;
      height: 26px;
    }

    .error_value_answer {
      color: RGBA(255, 49, 49, 1);
    }

    .correct_value_answer {
      color: RGBA(0, 199, 88, 1);
    }

    .btn_ask {
      width: 64px;
      height: 28px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 14px;
      line-height: 28px;
      text-align: center;
      color: #fff;
    }

    .get_score {
      color: #FD673B;
    }
  }

  .question_analyze {
    color: #333333;
    font-weight: 600;
  }
}

:deep(.el-checkbox.el-checkbox--large) {
  display: flex;
  align-items: baseline;
  min-height: 36px;
  height: auto;
}

:deep(.el-checkbox__label) {
  line-height: normal;
}
</style>